export enum BillingEntityType {
    Fee = 'fee',
    Refund = 'refund',
    Payout = 'payout',
    Invoice = 'invoice',
    Transaction = 'transaction',
    Checkout = 'checkout',
}
